import ComponentCard from "../../../components/common/ComponentCard";
import PageMeta from "../../../components/common/PageMeta";
import Button from "../../../components/ui/button/Button";
import HeadingTable from "./HeadingTable";
import { useLocation, useNavigate } from "react-router-dom";


const Heading = () => {
  const navigate = useNavigate();

  return(
    <>
      <PageMeta 
        title="Compliance Inspections - Headings | Hospitality Genie"
        description="Compliance Inspections - Headings"
      />
      <div className="space-y-6">
      <ComponentCard title="Compliance Inspections - Headings">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">Headings</div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <Button
              className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]" size="sm" 
              onClick={() => navigate('/add-new-heading')}
            >
              Add New Heading
            </Button>
            </div>
        </div>
        
        <div>
          {/* Table Component */}
          <HeadingTable />
        </div>
      </ComponentCard>
      </div>
    </>
  );

}

export default Heading;